import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RichTextComponent } from '@domgen/dgx-fe-components/content';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';

@Component({
  standalone: true,
  selector: 'checkout-protection-confirmation-panel-header',
  templateUrl: './protection-confirmation-panel-header.component.html',
  styleUrls: ['./protection-confirmation-panel-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PanelComponent, QMSanitiseDirective, RichTextComponent],
})
export class ProtectionConfirmationPanelHeaderComponent {
  @Input() content?: string;
}
